export default {
  name: '',
  type: 'guest',
  muted: true,
  video_off: false,
  order: 0,
  avatar: '',
  selected: false,
  hidden: false,
  showSelection: true,
  screenShare: false,
  previousGroup: '',
  groups: ['all'],
  element: null,
  officeNumber: '',
  assignment_status: null,
  assignment_order: 0,
  info: null,
};
